import React, { useEffect } from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilCursor,
  cilSpeedometer,
  cilUser,
  cilGamepad,
  cilUserPlus,
  cilControl,
  cilSettings,
  cilCalendarCheck,
  cilThumbUp,
  cilBolt,
  cibWhatsapp,
  cilListRich,
  cilVideo,
  cilCreditCard,
  cilTransfer,
  cilLink,
  cilInfo,
  cilLifeRing,
  cilCloudDownload,
  cilCloudUpload,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'
const handleClick = (event) => {
  window.Produktly.openChangelog({ id: 240 })
  event.preventDefault()
  // Add any additional logic you need here
}
const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },

  {
    component: CNavItem,
    name: `Get Started`,
    to: '/get-started',
    icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: 'Quick Links',
    id: 'quick-links-group', // Add unique ID
    to: '/spots',
    icon: <CIcon icon={cilLink} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate Game',
        to: '/activate-game',
      },
      {
        component: CNavItem,
        name: 'Game Info',
        to: '/game-info',
      },
      {
        component: CNavItem,
        name: 'Game Spot',
        to: '/spots',
      },
      {
        component: CNavItem,
        name: 'Game Structure',
        to: '/game-structure',
      },
      {
        component: CNavItem,
        name: 'Manage Scores',
        to: '/manage-scores',
      },
      {
        component: CNavItem,
        name: 'Members List',
        to: '/members',
      },
      {
        component: CNavItem,
        name: 'Players List',
        to: '/players',
      },
      {
        component: CNavItem,
        name: 'Point System',
        to: '/point-system',
      },

      {
        component: CNavItem,
        name: 'Rounds',
        to: '/rounds',
      },
      {
        component: CNavItem,
        name: 'Sponsors',
        to: '/sponsors',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Analytics',
    to: '/',
    icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Members',
        to: '/member-analytics',
      },
      {
        component: CNavItem,
        name: 'Players',
        to: '/player-analytics',
      },
      {
        component: CNavItem,
        name: 'Game',
        to: '/game-analytics',
      },
      {
        component: CNavItem,
        name: 'Game Charts',
        to: '/game-charts',
      },
      {
        component: CNavItem,
        name: 'Game Bars',
        to: '/game-bars',
      },
      {
        component: CNavItem,
        name: 'Branding Log',
        to: '/branding-log',
      },
      {
        component: CNavItem,
        name: 'Sponsor Log',
        to: '/sponsor-logs',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Trades',
    to: '/',
    icon: <CIcon icon={cilTransfer} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Trades Used',
        to: '/trades-used',
      },
      {
        component: CNavItem,
        name: 'Trades Log',
        to: '/trades-log',
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'Game Setup',
  },
  {
    component: CNavGroup,
    name: 'Settings',
    to: '/',
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'About Game',
        to: '/club-about-game',
      },
      {
        component: CNavItem,
        name: 'Game Structure',
        to: '/game-structure',
      },
      {
        component: CNavItem,
        name: 'Fantasy Values',
        to: '/fantasy-values',
      },
      {
        component: CNavItem,
        name: 'Rounds',
        to: '/rounds',
      },
      {
        component: CNavItem,
        name: 'Comps',
        to: '/comps',
      },
      {
        component: CNavItem,
        name: 'Teams',
        to: '/teams',
      },
      {
        component: CNavItem,
        name: 'Point System',
        to: '/point-system',
      },
      {
        component: CNavItem,
        name: 'Bonus Points',
        to: '/bonus-points',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Controls',
    to: '/',
    icon: <CIcon icon={cilControl} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Game Spots',
        to: '/spots',
      },
      {
        component: CNavItem,
        name: 'Powers',
        to: '/power-control',
      },
      {
        component: CNavItem,
        name: 'Branding',
        to: '/branding',
      },
      {
        component: CNavItem,
        name: 'Sponsors',
        to: '/sponsors',
      },

      // {
      //   component: CNavItem,
      //   name: 'Prizes',
      //   to: '/prizes',
      // },
      {
        component: CNavItem,
        name: 'Notifications',
        to: '/game-notifications',
      },
      {
        component: CNavItem,
        name: 'Articles',
        to: '/articles',
      },
      {
        component: CNavItem,
        name: 'Team Alerts',
        to: '/team-alerts',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Players',
    to: '/',
    icon: <CIcon icon={cilUserPlus} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Players List',
        to: '/players',
      },
      {
        component: CNavItem,
        name: 'Players Team',
        to: '/player-teams',
      },
      {
        component: CNavItem,
        name: 'Player Availability ',
        to: '/availabilities',
      },
      {
        component: CNavItem,
        name: 'Player Profile ',
        to: '/players-profile',
      },
      {
        component: CNavItem,
        name: 'Player Stats ',
        to: '/players-stats',
      },
      {
        component: CNavItem,
        name: 'Player Values',
        to: '/players-values',
      },
      {
        component: CNavItem,
        name: 'Player Rounds',
        to: '/players-rounds',
      },
      {
        component: CNavItem,
        name: 'Inactive Players',
        to: '/inactive-players',
      },
      {
        component: CNavItem,
        name: 'Player Charts',
        to: '/player-charts',
      },
      {
        component: CNavItem,
        name: 'Player Sponsors',
        to: '/player-sponsors',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Fixtures',
    to: '/',
    icon: <CIcon icon={cilGamepad} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Create Fixtures',
        to: '/create-fixtures',
      },
      {
        component: CNavItem,
        name: 'Manage Scores',
        to: '/manage-scores',
      },
      {
        component: CNavItem,
        name: 'Completed Fixtures',
        to: '/completed-fixtures',
      },
      {
        component: CNavItem,
        name: 'Fixture Setting',
        to: '/fixture-setting',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Members',
    to: '/',
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Members List',
        to: '/members',
      },
      {
        component: CNavItem,
        name: 'Manage Members',
        to: '/manage-members',
      },
      {
        component: CNavItem,
        name: 'Verify Members',
        to: '/verify-as-player',
      },
      {
        component: CNavItem,
        name: 'Fantasy Leaderboard',
        to: '/fantasy-leaderboard',
      },
      {
        component: CNavItem,
        name: 'Game Codes',
        to: '/game-codes',
      },
      {
        component: CNavItem,
        name: 'Member Invites',
        to: '/member-invites',
      },
      // {
      //   component: CNavGroup,
      //   name: 'Verifications',
      //   to: '/',
      //   items: [
      //     {
      //       component: CNavItem,
      //       name: 'Paid Members',
      //       to: '/paid-members',
      //     },
      //   ],
      // },
    ],
  },
  {
    component: CNavGroup,
    name: 'Imports',
    to: '/',
    icon: <CIcon icon={cilCloudUpload} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Fixtures',
        to: '/fixture-import',
      },
      {
        component: CNavItem,
        name: 'Players',
        to: '/player-import',
      },
      {
        component: CNavItem,
        name: 'Rounds',
        to: '/round-import',
      },
      {
        component: CNavItem,
        name: 'Squads',
        to: '/squad-import',
      },
    ],
  },

  {
    component: CNavItem,
    name: 'Downloads',
    to: '/downloads',
    icon: <CIcon icon={cilCloudDownload} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: 'Email Alerts',
  },
  {
    component: CNavGroup,
    name: 'Email Alerts',
    id: 'emaila-alerts-group', // Add unique ID
    to: '/email-purchase',
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Purchase',
        to: '/purchase-email-alerts',
      },
      {
        component: CNavItem,
        name: 'Send',
        to: '/send-email-alerts',
      },
      {
        component: CNavItem,
        name: 'Track',
        to: '/track-email-alerts',
      },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: 'Analytics',
  //   to: '/',
  //   icon: <CIcon icon={cilElevator} customClassName="nav-icon" />,
  //   badge: {
  //     color: 'danger-gradient',
  //     text: 'PRO',
  //   },
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: 'Members',
  //       to: '/',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Overall',
  //       to: '/',
  //     },
  //     {
  //       component: CNavItem,
  //       name: 'Players',
  //       to: '/',
  //     },
  //   ],
  // },
  {
    component: CNavTitle,
    name: 'Pro Add-Ons',
  },

  {
    component: CNavGroup,
    name: 'Bonus Cards',
    to: '/',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate',
        to: '/activate-bonus-card',
      },
      {
        component: CNavItem,
        name: 'Manage Bonus Cards',
        to: '/manage-bonus-cards',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Bracket Battle',
    to: '/',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate',
        to: '/activate-bracket-battle',
      },
      {
        component: CNavItem,
        name: 'Bracket Settings ',
        to: '/bracket-battle',
      },
      {
        component: CNavItem,
        name: 'Bracket Rounds',
        to: '/bracket-round',
      },
      {
        component: CNavItem,
        name: 'Round Points',
        to: '/bracket-battle/points',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Head-2-Head',
    to: '/',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate',
        to: '/activate-head-2-head',
      },
      {
        component: CNavItem,
        name: 'H2H Settings',
        to: '/h2h-settings',
      },
      {
        component: CNavItem,
        name: 'H2H Manage',
        to: '/h2h-manage',
      },
      {
        component: CNavItem,
        name: 'H2H Playoffs',
        to: '/h2h-play-off',
      },
      {
        component: CNavItem,
        name: 'H2H Leaderboard',
        to: '/h2h-leaderboard',
      },
    ],
  },

  {
    component: CNavGroup,
    name: 'Timeline',
    to: '/',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Settings',
        to: '/timeline-settings',
      },
      {
        component: CNavItem,
        name: 'Fantasy Timeline',
        to: '/timeline-listing/fantasy',
      },
      {
        component: CNavItem,
        name: 'Goals Timeline',
        to: '/timeline-listing/go',
      },
      {
        component: CNavItem,
        name: 'Assists Timeline',
        to: '/timeline-listing/ast',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Team of the Round',
    to: '/',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate TOTR',
        to: '/activate-team-of-the-round',
      },
      {
        component: CNavItem,
        name: 'Manage TOTR',
        to: '/manage-team-of-the-round',
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Votes',
    to: '/fixture-votes',
    icon: <CIcon icon={cilBolt} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate Votes',
        to: '/activate-fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Fixture Votes',
        to: '/fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Team Votes',
        to: '/team-fixture-voting',
      },
      {
        component: CNavItem,
        name: 'Total Votes',
        to: '/total-voting',
      },
    ],
  },
  {
    component: CNavTitle,
    name: 'Billings',
  },
  {
    component: CNavGroup,
    name: 'Revenue',
    id: 'pricing-group', // Add unique ID
    to: '/game-pass',
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Game Pass',
        to: '/game-pass',
      },

      {
        component: CNavItem,
        name: 'Payments',
        to: '/game-payments',
      },
    ],
  },

  {
    component: CNavGroup,
    name: 'Game Activation',
    id: 'game-activation', // Add unique ID
    to: '/pricing-plan',
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Activate Game',
        to: '/activate-game',
      },
      {
        component: CNavItem,
        name: 'Game Info',
        to: '/game-info',
      },
      {
        component: CNavItem,
        name: 'Pricing Plan',
        to: '/pricing-plan',
      },
    ],
  },

  // {
  //   component: CNavItem,
  //   name: 'Invoices',
  //   to: '/',
  //   icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  // },
  {
    component: CNavTitle,
    name: 'Links',
  },
  {
    component: CNavItem,
    name: `What's New`,
    to: '#',
    icon: <CIcon icon={cilListRich} customClassName="nav-icon" />,
    onClick: handleClick,
  },
  {
    component: CNavItem,
    name: 'Admin Community',
    to: 'https://chat.whatsapp.com/Hlp4McKF83vJ9mlqyXDmvb',
    icon: <CIcon icon={cibWhatsapp} customClassName="nav-icon" />,
  },

  {
    component: CNavItem,
    name: 'Admin Help Tours',
    to: 'https://share.layerpath.com/playlist/clyd0i2b5000cjo0c78apwfkv',
    icon: <CIcon icon={cilVideo} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Help Center',
    to: 'https://myclubtap.tawk.help/',
    icon: <CIcon icon={cilLifeRing} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Book Intro Session',
    to: 'https://calendly.com/vickyatmyclubtap/myclubtapintroforgameadminsin30mins?back=1&month=2023-08',
    icon: <CIcon icon={cilCalendarCheck} customClassName="nav-icon" />,
  },

  {
    component: CNavItem,
    name: 'Share Feedback',
    to: 'https://testimonials.myclubtap.com/',
    icon: <CIcon icon={cilThumbUp} customClassName="nav-icon" />,
  },
]

export default _nav
